<template lang="pug">
  //- v-layout.justify-center.pt-5.px-5.font-italic.text-xs-center.subheading.grey--text.text--darken-2(v-if="(!object.user || !object.user.has_password) && type !== 'client'")
    |Le contact n'a pas encore d'accès STUDIO
    |, il est nécessaire d'en créer un avant de pouvoir lui affecter des rôles.
  v-tabs.destination-tabs(slider-color="primary" v-if="$store.state.app.destination.id === 1 && object.touristic_provider" hide-slider)
    v-tab(
      v-for="(destination, index) in destinations"
      :key="destination.id"
    )
      span {{ destination.name }} {{ roleCounts[index] }}
    v-tab-item.pt-4(
      v-for="(destination, index) in destinations"
      :key="destination.id"
    )
      rc-user-roles(:useDestinationId="destination.id" @gotRoles="roles => setRoleCount(index, roles)")
  rc-user-roles(v-else)
</template>

<script>
import RcUserRoles from '@/components/RcUserRoles/RcUserRoles.vue';

export default {
  components: {
    RcUserRoles,
  },
  data() {
    return {
      object: this.$store.state.app.focusedObject,
      type: this.$route.meta.type,
      roleCounts: [],
    }
  },
  methods: {
    setRoleCount(index, roles) {
      const affectable = roles.affectable.filter((thing, index, self) => { return self.findIndex(t => t.role_id === thing.role_id) === index })
      const total = affectable.length;
      const affected = affectable
        .filter(x => roles.affected.some(role => role.role_id === x.role_id)).length;
      this.$set(this.roleCounts, index, `(${affected}/${total} roles)`);
    }
  },
  computed: {
    destinations() {
      return this.$store.state.app.focusedParentDestinations;
    },
  },
};
</script>

<style lang="scss">
  .destination-tabs .v-tabs__div {
    max-width: 500px;
  }
  .v-tabs__item {
    &.v-tabs__item--active {
      border-bottom: 2px solid var(--primary);
    }
    &:not(.v-tabs__item--active) {
      padding-bottom: 8px;
    }
    transition: border-bottom 0s;
  }
</style>
